import camelCase from 'lodash/camelCase';

import { ProcessedInputSchema, ResponseSchema } from 'Lib/schemas';

import { EMPTY_FIELD_VALUES } from './initialState';

export const onboardingFieldsSchema = new ProcessedInputSchema((fields) => {
  const values = {};
  const editable = {};
  const required = {};
  const consents = {};

  fields.forEach((field) => {
    const key = camelCase(field.name);
    if (!(key in EMPTY_FIELD_VALUES)) {
      if (__CLIENT__ && __DEVELOPMENT__) {
        console.warn(`Onboarding field ${key} not recognized...?`);
        return;
      }
    }
    editable[key] = field.editable ?? true;
    required[key] = field.required ?? true;

    // Default fallback value we define
    const emptyValue = values[key] ?? EMPTY_FIELD_VALUES[key];
    // Default/original value provided by backend
    const defaultFieldValue = field.default ?? emptyValue;

    const data = field.data ?? defaultFieldValue;

    if (key === 'consents' && data) {
      values[key] = data.map((consent) => {
        consents[consent.consentId] = consent;
        return {
          id: consent.consentId,
          checked: consent.checked,
        };
      });
    } else {
      values[key] = data;
    }
  });
  return {
    consents,
    editable,
    required,
    values,
  };
});

export const onboardingFieldsResponseSchema = new ResponseSchema(
  {
    fields: onboardingFieldsSchema,
  },
  {
    processResult: {
      consents: ['fields', 'consents'],
      editableFields: ['fields', 'editable'],
      isReactivated: 'isReactivated',
      isUnderage: 'isUnderage',
      hasRedactedEnabled: 'hasRedactedEnabled',
      requiredFields: ['fields', 'required'],
      values: ['fields', 'values'],
    },
  }
);
